module.exports = __webpack_public_path__ + "static/media/signup.31988ff5.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/constants/video-captions/signup.vtt
// module id = 2175
// module chunks = 0